
import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './corruption.json';

const Corruption = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            
            description="Anti-corruption, transparency, and governance vocabulary. B2/C1 level reading, grammar, and discussion exercises."
            level="B2"
            title="Corruption"
            image="/Images/enron.webp"
            seoTitle="Free English Lesson Plans: Corruption"
            seoDescription="Anti-corruption, transparency, and governance vocabulary. B2/C1 level reading, grammar, and discussion exercises."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
            ))}
        </TopicsPageLayout>
    </div>
  );
};

export default Corruption;


